// @owners { team: patients-team }
export const IMAGE_DIMENSIONS = {
  width: 328,
  height: 268,
};
